import React from 'react';
import { toast } from 'react-toastify';
import { Button, } from 'reactstrap';
import { useToggle } from 'react-use';

export default function DeleteEventAnswersButton ({ targetEntries = [], onFinish = null, disabled, ...extraProps }) {
  const [isDeleting, toggleDeleting] = useToggle();
  const onClickDelete = async (props) => {
    if (!window.confirm(`${targetEntries.length}件の回答を削除しますか？`)) return;

    toggleDeleting(true);
    await Promise.all(targetEntries.map(entry => entry.ref.update({ answers: {}, frames: entry.frames.map(_ => ({ ..._, laterAnswers: {} })) })));
    onFinish && await onFinish();
    toast.success('削除しました');
    toggleDeleting(false);
  }

  return targetEntries.length !== 0 && (
    <Button color="danger" onClick={onClickDelete} disabled={disabled || isDeleting} {...extraProps}>
      <span className="fas fa-trash mr-1" />
      選択した回答を削除
    </Button>
  );
};
